package com.anjuros.website.redesign.sections.about

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.AboutQuoteStyle
import com.anjuros.website.redesign.styles.AboutStoryGridStyle
import com.anjuros.website.redesign.styles.AboutStoryTextStyle
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/** Founding quote on the left, the story on the right. */
@Composable
fun AboutStorySection() {
    RdSection(id = "story", labelledBy = "story-h", wrapModifier = AboutStoryGridStyle.toModifier()) {
        RdTag("figure", AboutQuoteStyle.toModifier()) {
            RdTag("blockquote") { P { Text(LocalText(RdText.ABOUT_QUOTE)) } }
            RdTag("figcaption") { Text(LocalText(RdText.ABOUT_QUOTE_CAPTION)) }
        }
        Div(AboutStoryTextStyle.toModifier().toAttrs()) {
            Div {
                RdEyebrow(RdText.ABOUT_STORY_EYEBROW)
                H2(RdH2Style.toModifier().id("story-h").toAttrs()) { Text(LocalText(RdText.ABOUT_STORY_TITLE)) }
            }
            StoryPart(RdText.ABOUT_WHY_TITLE) { P { Text(LocalText(RdText.ABOUT_WHY_TEXT)) } }
            StoryPart(RdText.ABOUT_BACKGROUND_TITLE) {
                P { Text(LocalText(RdText.ABOUT_BACKGROUND_TEXT1)) }
                P { Text(LocalText(RdText.ABOUT_BACKGROUND_TEXT2)) }
            }
            StoryPart(RdText.ABOUT_WHO_TITLE) {
                P {
                    Text(LocalText(RdText.ABOUT_WHO_TEXT_START))
                    RdLink(RdRoute.TRADES) { Text(LocalText(RdText.ABOUT_WHO_LINK)) }
                    Text(LocalText(RdText.ABOUT_WHO_TEXT_END))
                }
            }
        }
    }
}

@Composable
private fun StoryPart(title: RdText, content: @Composable () -> Unit) {
    Div {
        H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
        content()
    }
}
